import { DateFormat, formatDateTimeWithLocale } from '@frontend/common';
import { SensorLockerStatus } from '@frontend/device/types';
import { CommonMessage, useLocale } from '@frontend/lang';
import { UserBadge } from '@frontend/user/badge';
import { LuCalendar, LuUser } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import LargeSlotCard from '../../../components/slot-cards/large-slot-card.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import useReviewDetail from './review-detail.controller';

const ID = 'review-detail';

const ReviewDetail = () => {
    const { locale } = useLocale();
    const viewProps = useReviewDetail();

    return (
        <WizardScreenContainer
            id={ID}
            loadingModal={{
                show: viewProps.isProcessing
            }}
            footer={{
                onSubmit: viewProps.handleSubmit,
                submitDisabled: viewProps.isProcessing || !viewProps.slot,
                submitLabel: (
                    <FormattedMessage
                        id='kiosk.manage-spot.view-content-slot-detail.open-slot'
                        defaultMessage='Open SLOT {name}'
                        values={{ name: viewProps.slot?.display ?? '' }}
                    />
                )
            }}>
            <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                <div className='text-foreground-default justify-end'>
                    <FormattedMessage
                        defaultMessage='Selected product'
                        id='kiosk.wizard.lending-review-detail.selected-product'
                        description='Instruction text on the lending review detail screen, showing the selected product'
                    />
                </div>
                <ProductCard
                    variant='attributes'
                    product={viewProps.product}
                    equipment={viewProps.equipment}
                    description={
                        <div className='flex flex-col items-start justify-start gap-1 self-stretch'>
                            {viewProps.transaction?.creation_timestamp ? (
                                <div className='text-brand-muted inline-flex items-center justify-start gap-2 self-stretch text-base font-medium'>
                                    <LuCalendar className='size-5' />
                                    {formatDateTimeWithLocale(new Date(viewProps.transaction.creation_timestamp), locale, DateFormat.DD_MM_YYYY_HH_MM)}
                                </div>
                            ) : null}
                            {viewProps.transaction && 'user' in viewProps.transaction && viewProps.transaction.user ? (
                                <div className='inline-flex items-center justify-start gap-2 self-stretch'>
                                    <LuUser className='size-5' />
                                    <UserBadge
                                        id={viewProps.transaction.user.entity_id}
                                        className='text-brand-muted justify-start text-base font-medium'
                                    />
                                </div>
                            ) : null}

                            {viewProps.product && (
                                <div className='text-brand-muted inline-flex items-center justify-start gap-2 self-stretch text-base font-medium'>
                                    {CommonMessage.OBJECTS.PRODUCT.EAN} {viewProps.product?.ean ?? '-'}
                                </div>
                            )}
                            {viewProps.product && (
                                <div className='text-brand-muted inline-flex items-center justify-start gap-2 self-stretch text-base font-medium'>
                                    {CommonMessage.OBJECTS.PRODUCT.SKU} {viewProps.product?.sku ?? '-'}
                                </div>
                            )}
                        </div>
                    }
                />

                {viewProps.slot && (
                    <LargeSlotCard
                        slot={viewProps.slot}
                        status={SensorLockerStatus.CLOSED}
                    />
                )}
            </div>
        </WizardScreenContainer>
    );
};

export default ReviewDetail;
